import { useState, useEffect, useRef } from 'react';
import { MeshStandardMaterial, BoxGeometry } from 'three';
import { useGLTF } from '@react-three/drei';
import { useThree } from "@react-three/fiber"
import * as THREE from "three"

const InteractiveButton = ({ node, color, onClick, position, scale }) => {
  const [material, setMaterial] = useState(null);
  const meshRef = useRef();

  const {camera} = useThree()

  const checkDistance = (objectPosition) => {
    const cameraPosition = new THREE.Vector3();
    camera.getWorldPosition(cameraPosition);
    const objectPositionVec = new THREE.Vector3(...objectPosition); // розпаковуємо масив координат
    const distance = cameraPosition.distanceTo(objectPositionVec);

    return distance <= 1.5;
  };


  // Функція для створення нового матеріалу
  const createNewMaterial = (color) => {
    return new MeshStandardMaterial({
      color: color,
      emissive: color,
      emissiveIntensity: 0.1,
    });
  };

  // Встановлення нового матеріалу для ноди після завантаження моделі
  useEffect(() => {
    if (node) {
      const newMaterial = createNewMaterial(color);
      node.material = newMaterial;
      setMaterial(newMaterial);
    }
  }, [node, color]);

  const handlePointerOver = () => {
    if (!checkDistance([-13.26, 1.38, 3.765])) return
    if (material) {
      material.emissiveIntensity = 0.5;
    }
  };

  const handlePointerOut = () => {
    if (material) {
      material.emissiveIntensity = 0.1;
    }
  };

  const handleClick = () => {
    if (!checkDistance([-13.26, 1.38, 3.765])) return
    if (onClick) onClick();
  };

  return (
    <group
      onPointerOver={handlePointerOver}
      onPointerOut={handlePointerOut}
    >
      {/* Примітив тексту */}
      <primitive
        ref={meshRef}
        object={node}
        position={position}
        scale={scale}
      />
      {/* Блок позаду тексту */}
      <mesh
        position={[position[0], position[1], position[2]]} // Встановлення позиції позаду тексту
        scale={[1, 1, 1]} // Розмір блока
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
        onClick={handleClick}
        rotation={[0, Math.PI / 2, 0]}
      >
        <planeGeometry args={[1.2, 0.3]} />
        <meshStandardMaterial
          transparent={true} // Додаємо прозорість
          opacity={0} // Встановлюємо рівень прозорості (0 - повністю прозорий, 1 - повністю непрозорий)
        />
      </mesh>
    </group>
  );
};

export { InteractiveButton };
